import { Stars } from './Stars';
import { Card } from '../Card'

const reviewStyle = { width: '300px' };

export function Review({ starCount, children }){
  return (
    <Card style={reviewStyle}>
      <div>
        { children }
      </div>
      <Stars starCount={starCount} starTotal={5} />
    </Card>
  );
}